import { CircularProgress, Stack, Typography } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useEffect } from "react";
import { useSailorRiskProfile } from "../hooks/useSailorRiskProfile";
import { useSailorContext } from "../SailorContext";
import { CreditChecks } from "../../CreditCheck/CreditChecks";
import { OpenBanking } from "../../OpenBanking/OpenBanking";
import { OpenBankingRedFlags } from "../../OpenBanking/OpenBankingRedFlags";
import { PanelGroup } from "@poseidon/ui/components/Panel";
import { SailorCheckList } from "../../CheckList/components/SailorCheckList";
import { useParams } from "react-router-dom";

export function SailorRiskProfileCreditUnderwriting() {
  const { applicationId } = useParams();

  const sailor = useSailorContext();
  const { setError } = useErrorMessage();
  const { sailorRiskProfile, loading, error } = useSailorRiskProfile({
    sailorId: sailor.id,
  });

  useEffect(() => {
    if (error) {
      setError(error);
    }
  });

  if (loading || !sailorRiskProfile) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <OpenBankingRedFlags sailorId={sailor.id} />
      <Typography variant="h5" component="h3">
        Credit Checks
      </Typography>
      <PanelGroup>
        <SailorCheckList
          title="Prerequisites"
          sailor={sailor}
          target="creditCheck"
        />
        <CreditChecks sailorId={sailor.id} applicationId={applicationId} />
      </PanelGroup>
      <Typography variant="h5" component="h3">
        Supporting Documentation
      </Typography>
      <OpenBanking sailorId={sailor.id} applicationId={applicationId} />
    </Stack>
  );
}
